"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("./table.css");

exports.default = {
  table: 'pf-c-table',
  tableExpandableRow: 'pf-c-table__expandable-row',
  tableSort: 'pf-c-table__sort',
  tableCompoundExpansionToggle: 'pf-c-table__compound-expansion-toggle',
  button: 'pf-c-button',
  tableToggle: 'pf-c-table__toggle',
  tableCheck: 'pf-c-table__check',
  tableAction: 'pf-c-table__action',
  tableInlineEditAction: 'pf-c-table__inline-edit-action',
  tableSortIndicator: 'pf-c-table__sort-indicator',
  tableExpandableRowContent: 'pf-c-table__expandable-row-content',
  tableIcon: 'pf-c-table__icon',
  tableIconInline: 'pf-c-table__icon-inline',
  modifiers: {
    'hidden': 'pf-m-hidden',
    'hiddenOnSm': 'pf-m-hidden-on-sm',
    'visibleOnSm': 'pf-m-visible-on-sm',
    'hiddenOnMd': 'pf-m-hidden-on-md',
    'visibleOnMd': 'pf-m-visible-on-md',
    'hiddenOnLg': 'pf-m-hidden-on-lg',
    'visibleOnLg': 'pf-m-visible-on-lg',
    'hiddenOnXl': 'pf-m-hidden-on-xl',
    'visibleOnXl': 'pf-m-visible-on-xl',
    'hiddenOn_2xl': 'pf-m-hidden-on-2xl',
    'visibleOn_2xl': 'pf-m-visible-on-2xl',
    'heightAuto': 'pf-m-height-auto',
    'center': 'pf-m-center',
    'expanded': 'pf-m-expanded',
    'plain': 'pf-m-plain',
    'wrap': 'pf-m-wrap',
    'selected': 'pf-m-selected',
    'noPadding': 'pf-m-no-padding',
    'compact': 'pf-m-compact',
    'noBorderRows': 'pf-m-no-border-rows',
    'expandable': 'pf-m-expandable',
    'fitContent': 'pf-m-fit-content',
    'width_10': 'pf-m-width-10',
    'width_15': 'pf-m-width-15',
    'width_20': 'pf-m-width-20',
    'width_25': 'pf-m-width-25',
    'width_30': 'pf-m-width-30',
    'width_35': 'pf-m-width-35',
    'width_40': 'pf-m-width-40',
    'width_45': 'pf-m-width-45',
    'width_50': 'pf-m-width-50',
    'width_60': 'pf-m-width-60',
    'width_70': 'pf-m-width-70',
    'width_80': 'pf-m-width-80',
    'width_90': 'pf-m-width-90',
    'widthMax': 'pf-m-width-max'
  }
};